import React from "react";

const Privacy = (props) => {
  return (
    <div class="article">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1>Legal Notice</h1>
            <div class="col-xs-12">
              <h2>1. Website publisher</h2>
              <p>
                The davoyage.com website is published by <strong>David Imirzian</strong>,
                trading as <strong>Davoyage</strong>, a French sole
                proprietorship (Entrepreneur Individuel).
                <br />
                Registered address: 10 rue de Nazareth, 69003 Lyon, France
                <br />
                SIREN: 479 817 249
                <br />
                SIRET (main establishment): 479 817 249 00010
                <br />
                Intra-community VAT number: FR83479817249
                <br />
                VTC registration (Atout France): EVTC069140133
                <br />
                Publication director: David Imirzian
                <br />
                Contact: <a href="mailto:contact@davoyage.com">contact@davoyage.com</a> — +33 6 60 26 53 36
              </p>

              <h2>2. Hosting</h2>
              <p>
                This website is hosted by Amazon Web Services EMEA SARL,
                38 avenue John F. Kennedy, L-1855 Luxembourg.
              </p>

              <h2>3. Intellectual property</h2>
              <p>
                All content on this site (text, images, logos, structure)
                is protected by copyright. Any reproduction, representation
                or distribution, in whole or in part, without the prior
                authorization of Davoyage, is prohibited and constitutes
                an infringement.
              </p>

              <h2>4. Personal data</h2>
              <p>
                Information collected through the quote request form
                (name, email, phone, trip addresses) is used solely to
                process your request and is never sold or shared with
                third parties beyond those strictly necessary to deliver
                the service (payment processing, trip routing).
              </p>
              <p>
                Under the General Data Protection Regulation (GDPR) and
                French data protection law, you have the right to access,
                rectify, delete and object to the data held about you.
                To exercise this right, contact{" "}
                <a href="mailto:contact@davoyage.com">contact@davoyage.com</a>.
              </p>

              <h2>5. Consumer mediation</h2>
              <p>
                In accordance with French law (Article L.616-1 of the
                Consumer Code), any consumer client has the right to
                refer, free of charge, to a consumer mediator for the
                amicable resolution of a dispute with Davoyage.
              </p>

              <h2>6. Governing law and disputes</h2>
              <p>
                This website and its terms of use are governed by French
                law. In the event of a dispute, and failing an amicable
                resolution, the courts of Lyon, France shall have
                exclusive jurisdiction.
              </p>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
